import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { connect } from 'react-redux';
import { Row, Col, Radio, Card, Divider, Button, Popconfirm } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import moment from 'moment';
import NumberFormat from 'react-number-format';


class HowItWorks extends Component {

    render() {
        return (
            <div>
                <div style={{ background: '#00abff'}}>
                    <Row>
                        <Col md={{span: 24}}>
                            <h1 style={{color: "#ffffff", margin: "12px", textAlign: 'center', fontWeight: 'bold'}}>How does Villaride work?</h1>
                        </Col>
                    </Row>
                </div>
                <div style={{ paddingTop: '24px' }}>
                                <Row gutter={16}>
                                    <Col md={{ span: 18, offset: 3 }}>
                                        <Card>
                                            <Row>
                                                <Col md={{ span: 24 }}>
                                                    <h1 style={{ fontWeight: "bold", color: '#0099ff' }}>
                                                        For Drivers
                                                    </h1>
                                                    <br/>
                                                    <h2>
                                                    As you drive your car from A to B, make money by filling those empty seats in your car with safe and reliable passengers
                                                    </h2>
                                                    <br/>
                                                    <Link to="/post-trip">
                                                        <Button type="primary" size='large' icon="plus">Post a Ride</Button>
                                                    </Link>

                                                </Col>
                                            </Row>

                                        </Card>
                                    </Col>
                                    </Row>
                                    <br/>
                                    
                                    <Row>
                                    <Col md={{ span: 18, offset: 3 }}>
                                        <Card>
                                            <Row>
                                                <Col md={{ span: 24 }}>
                                                    <h1 style={{ fontWeight: "bold", color: '#0099ff' }}>
                                                        For Passengers
                                                    </h1>
                                                    <br/>
                                                    <h2>
                                                    You want to travel to some place, but there is someone going to drive their car with empty seats in same direction. Travel with that person in their car. Its convenient and affordable.
                                                    </h2>
                                                    <br/>
                                                    <Link to="/find-ride">
                                                        <Button type="primary" size='large' icon="search" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }}>Find a Ride</Button>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                </div>
            </div>
        );
    }
}


export default HowItWorks;
